module.exports = __webpack_public_path__ + "static/media/woman-chef-kitchen-home.262b26b8.png";